import { ApiResponse } from "../types/common";
import {
  ZincApiLogFilter,
  ZincApiLogPagedResponse,
  ZincApiLogSummary,
} from "../types/zincApiLog";
import apiClient from "./apiClient";

export const getZincApiLogs = async (
  filter: ZincApiLogFilter
): Promise<ApiResponse<ZincApiLogPagedResponse>> => {
  const params = new URLSearchParams();
  params.append("pageNumber", filter.pageNumber.toString());
  params.append("pageSize", filter.pageSize.toString());
  params.append("period", filter.period);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate) params.append("endDate", filter.endDate);
  if (filter.endpointType) params.append("endpointType", filter.endpointType);
  if (filter.statusCode != null)
    params.append("statusCode", filter.statusCode.toString());
  const response = await apiClient.get(
    `/admin/zinc-logs?${params.toString()}`
  );
  return response.data;
};

export const getZincApiLogSummary = async (
  filter: ZincApiLogFilter
): Promise<ApiResponse<ZincApiLogSummary>> => {
  const params = new URLSearchParams();
  params.append("period", filter.period);
  if (filter.startDate) params.append("startDate", filter.startDate);
  if (filter.endDate) params.append("endDate", filter.endDate);
  if (filter.endpointType) params.append("endpointType", filter.endpointType);
  const response = await apiClient.get(
    `/admin/zinc-logs/summary?${params.toString()}`
  );
  return response.data;
};
